import React from 'react'

const Header = ({ sort, sortOrder, onSortChange, showEdit = true, showSelect = false }) => (
    <thead>
        <tr className="audience-list audience-list--header">
            {showSelect && <th className="audience-list audience-list--size">Sel</th>}
            <th style={{ width: '150px' }} className="audience-list audience-list--audience pointer" onClick={() => onSortChange('audienceId')}>
                Audience Id
                {sort === 'audienceId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            {/*
            <th style={{ width: '150px' }} className="audience-list audience-list--audience pointer" onClick={() => onSortChange('alternativeId')}>
                Alternative Id
                {sort === 'alternativeId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            */}
            <th className="audience-list audience-list--audience pointer" onClick={() => onSortChange('audienceName')}>
                Audience
                {sort === 'audienceName' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            {/*
            <th className="audience-list audience-list--audience pointer" onClick={() => onSortChange('description')}>
                Description
                {sort === 'description' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            */}
            <th className="audience-list audience-list--size pointer" onClick={() => onSortChange('creation')}>
                Created
                {sort === 'creation' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
        
            <th className="audience-list audience-list--size pointer" onClick={() => onSortChange('size_ar_cookie')}>
                Size AR
                {sort === 'size_ar_cookie' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
        
            <th className="audience-list audience-list--size pointer" onClick={() => onSortChange('size_ddp')}>
                Size Google
                {sort === 'size_ddp' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="audience-list audience-list--size pointer" onClick={() => onSortChange('size_adform')}>
                Size Adform
                {sort === 'size_adform' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            {showEdit === true && (
                <th className="audience-list audience-list--size" style={{ width: '20px' }}>
                    Edit
                </th>
            )}
            <th className="audience-list audience-list--size">Actions</th>
        </tr>
    </thead>
)

export default Header
